export default __webpack_public_path__ + "static/media/img-profile1.9d901df5.png";